var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWebChat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 86,
    viewBox: "0 0 101 86",
    fill: "#E6E7E8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 36.3702C0.5 16.3996 22.9312 0.150391 50.5001 0.150391C78.0755 0.150391 100.5 16.3995 100.5 36.3702C100.5 56.341 78.0687 72.5832 50.5001 72.5832C48.8477 72.5832 47.2356 72.5071 45.6298 72.3895C37.4748 81.3268 27.6008 85.8647 16.2747 85.8647C15.0906 85.8647 14.0136 85.1176 13.5587 83.9831C13.0972 82.8418 13.3514 81.5413 14.1943 80.6628C16.4218 78.3454 20.389 72.7976 23.1854 66.7102C9.10993 60.0902 0.5 48.6625 0.5 36.3702ZM71.3487 31.6091H76.3519C77.8483 31.7849 78.6812 32.6103 78.8571 34.1125V39.1191C78.6811 40.6212 77.8483 41.4467 76.3519 41.6091H71.3487C69.8524 41.4467 69.0197 40.6212 68.8571 39.1191V34.1125C69.0197 32.6105 69.8524 31.7849 71.3487 31.6091ZM52.9965 31.6091H47.9967C46.5014 31.7849 45.6694 32.6105 45.5 34.1125V39.1191C45.6694 40.6212 46.5014 41.4467 47.9967 41.6091H52.9965C54.4849 41.4467 55.3172 40.6212 55.5 39.1191V34.1125C55.3172 32.6103 54.4849 31.7849 52.9965 31.6091ZM24.6377 31.6091H29.6344C31.1285 31.7849 31.9467 32.6103 32.1429 34.1125V39.1191C31.9467 40.6212 31.1284 41.4467 29.6344 41.6091H24.6377C23.1432 41.4467 22.3118 40.6212 22.1429 39.1191V34.1125C22.3118 32.6105 23.1432 31.7849 24.6377 31.6091Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWebChat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WebChat.4cbe687e32b8042157684fcb614623f1.svg";